import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { GridList, GridTile } from '@material-ui/core/GridList';
import GridList from '@material-ui/core/GridList';
import GridTile from '@material-ui/core/GridListTile';
// import EditIcon from '@material-ui/core/svg-icons/editor/mode-edit';
// import AddIcon from '@material-ui/core/svg-icons/content/add-circle';

import { IconButton } from '@projeccions-pdc/react-icon';

import styles from './MeetingsAndCollectionsStyle';
import MeetingsAndCollectionsController from './Wizard/MeetingsAndCollectionsController';
import { getFileURL, getLocalizedName } from '../../../helpers';
import Loader from '../../Common/Loader';
import StoreController from '@projeccions-pdc/frontend-storage';
import { isSmartphone } from '../../../helpers';
import LocalizedStrings from '../../Localization/localization';
import AppContext from '../../../AppContext';

class Collections extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collections: undefined,
            loading: true,
        };

        this._MeetingsAndCollectionsController = new MeetingsAndCollectionsController(this);
        let appContext = new AppContext();
        let currentUserSub = appContext.getMyInfo().userSub;
        this._StoreController = new StoreController(appContext.getPlatformId(), currentUserSub);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    async componentDidMount() {
        let appContext = new AppContext();
        appContext.addObserver('colComponent', this);
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
        await this.refreshCollections();
    }

    componentWillUnmount() {
        this.removeListener();
        let appContext = new AppContext();
        appContext.removeObserver('colComponent');
    }

    notifyDataHasChanged = async () => {
        await this.refreshCollections();
    };

    async componentDidUpdate(prevProps, prevState) {
        // if (prevProps.platformId !== this.props.platformId) {
        //     await this.refreshCollections();
        // }
    }

    async refreshCollections() {
        try {
            // console.log('refreshCollections')
            let collections = this._StoreController.get('cols');
            this.setState({ collections, loading: false });
            collections = await this._MeetingsAndCollectionsController.getCollections();
            //console.log('collectionIds', collections)

            this.setState({ collections, loading: false });
            this._StoreController.set('cols', collections);
        } catch (err) {
            // console.log('refreshCollections', err.message);
            if (err.message.indexOf('404') !== -1) {
                let collections = [];
                this.setState({ collections, loading: false });
                this._StoreController.set('cols', collections);
            } else {
                this.setState({ loading: false });
            }
        }
    }

    handleCollectionSelected = (evt, collection, action) => {
        this.props.openContent(collection.contentId, collection.objectType, action, evt);
        if (this.props.onCollectionSelected) {
            this.props.onCollectionSelected(collection);
        }
    };

    handleCollectionEdit = (evt, collection, action) => {
        evt.stopPropagation();
        this.handleCollectionSelected(evt, collection, action);
    };

    handleOpenModal = () => {
        if (this.props.openModal) {
            this.props.openModal('col');
        }
    };

    render() {
        let title = (
            <div style={styles.titleContainer}>
                {this.props.canCreate ? (
                    <IconButton name="md-add-circle" primaryColor="#fff" size={'20px'} onClick={this.handleOpenModal} />
                ) : (
                    ''
                )}
                {' Collections'}
            </div>
        );
        if (this.state.loading) {
            return (
                <div>
                    {title}
                    <Loader loading={true} size={'30px'} />
                </div>
            );
        }
        if (this.state.collections) {
            let collections = this.state.collections.sort(function (a, b) {
                return new Date(b.dateUpdated) - new Date(a.dateUpdated);
            });

            let columns = 4;
            if (this.state.smartphoneView === true) {
                columns = 2;
            }
            let language = new AppContext().getLanguage();
            return (
                <div>
                    {title}
                    {collections.length > 0 ? (
                        <div style={{ textAlign: 'left', padding: '10px 0px' }}>
                            <GridList cols={columns} spacing={10} cellHeight={150} style={styles.gridList}>
                                {collections.map((col) => {
                                    let url = col.previewImage ? 'url(' + getFileURL(col.previewImage) + ')' : undefined;
                                    let selectedStyle =
                                        this.props.selectedCollection && this.props.selectedCollection.contentId === col.contentId
                                            ? { border: '2px solid #4c90ff' }
                                            : {};
                                    return (
                                        <GridTile
                                            key={col.contentId}
                                            data-id={col.contentId}
                                            data-type="col"
                                            cols={1}
                                            rows={1}
                                            onClick={(evt) => this.handleCollectionSelected(evt, col, 'show')}
                                            style={{ cursor: 'pointer', ...selectedStyle }}
                                        >
                                            <div style={{ ...styles.collectionsItemImage, backgroundImage: url }}></div>
                                            <div style={styles.collectionItemTitleContainer}>
                                                <div
                                                    style={styles.collectionItemName}
                                                    dangerouslySetInnerHTML={{ __html: getLocalizedName(language, col.names) }}
                                                />

                                                {this.props.canEdit ? (
                                                    <div style={styles.editIconStyle}>
                                                        {/* <EditIcon color="#000" style={{ height: '10px', width: '10px' }} /> */}
                                                        <IconButton
                                                            name="md-mode-edit"
                                                            data-id="col-edit-btn"
                                                            primaryColor="#000"
                                                            size={'15px'}
                                                            onClick={(evt) => this.handleCollectionEdit(evt, col, 'edit')}
                                                        />
                                                    </div>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </GridTile>
                                    );
                                })}
                            </GridList>
                        </div>
                    ) : (
                        <div style={styles.noContentPlaceholder}>{LocalizedStrings.noCols}</div>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    {title}
                    <div style={{ textAlign: 'left', padding: '10px' }}>
                        <div style={styles.noContentPlaceholder}>{LocalizedStrings.noCols}</div>
                    </div>
                </div>
            );
        }
    }
}
Collections.propTypes = {
    canCreate: PropTypes.bool.isRequired,
    canEdit: PropTypes.bool.isRequired,
    openModal: PropTypes.func,
    openContent: PropTypes.func.isRequired,
    onCollectionSelected: PropTypes.func,
    selectedCollection: PropTypes.object,
};

export default Collections;
